import styled from "styled-components";

export const OverviewContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 56px 48px;
  box-sizing: border-box;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const OverviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 32px;
`;

export const OverviewHeading = styled.h1`
  color: ${({ theme }) => theme.text.text};
  font-family: "PP Formula";
  font-size: 18px;
  font-weight: 500;
  line-height: 18px;
  margin: 0;
`;

export const OverviewDescription = styled.div`
  color: ${({ theme }) => theme.text.text};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  opacity: 0.7;
`;

export const TemplatesContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 32px;
`;

export const TemplatesHeader = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const OverviewHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const OverviewTemplatesContainer = styled.div`
  ${({ isGrid = false }) =>
    isGrid
      ? `
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 40px;
      `
      : `
      display: flex;
      flex-direction: column;
      row-gap: 56px;
      `}
`;

export const TemplatesHeading = styled.h1`
  color: ${({ theme }) => theme.text.input};
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
`;

export const Link = styled.div`
  color: ${({ theme }) => theme.text.brand};
  font-family: "PP Formula";
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
`;
